const state = {
  paypalResource: null,
  cart: {},
  billing: {},
  closeupWatchTime: 0,
  closeupVideoUploadProgess: 0
}
export default state
